<!--
 * @Author: your name
 * @Date: 2020-09-15 08:56:38
 * @LastEditTime: 2020-09-21 09:02:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi-wap\src\components\publicHead.vue
-->
<template>
<div id="public-head" :style="{backgroundImage:`url(${background})`}">
    <p class="title">{{title}}</p>
    <p class="en-title">{{enTitle}}</p>
    <div class="list" v-if="list&&list.length>0">
        <div v-for="(item,index) in list" :class="{active:index==active1}" @click="check(index)">{{item}}</div>
    </div>
</div>
</template>

<script>
export default {
    name: "publicHead",
    props: ["background", "title", "en-title", "list", "active"],
    data() {
        return {
            active1: 0,
        };
    },
    watch: {
        active(e) {
            this.active1 = e
        },
    },
    created() {
        this.active1 = this.active || 0
    },
    methods: {
        check(e) {
            this.$emit("check", e);
        },
    },
};
</script>

<style lang="less" scoped>
#public-head {
    width: 100%;
    height: 3.7rem;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;

    align-items: center;
    flex-direction: column;
    position: relative;

    .title {
        font-size: 0.36rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 0.24rem;
    }

    .en-title {
        font-size: 0.3rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
    }

    .list {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: absolute;
        bottom: 0;
        transform: translateY(0.65rem);
        background: #ffffff;
        box-shadow: 0px 0px 0.25rem 0px rgba(18, 111, 204, 0.2);
        border-radius: 10px;
        overflow: hidden;

        div {
            line-height: 1.1rem;
            padding: 0 0.4rem;
            font-size: 0.32rem;
            font-weight: 400;
            font-family: Source Han Sans CN;
            transition: all 0.15s linear;
        }

        div.active {
            font-weight: bold;
            color: #ffffff;
            background: #126fcc;
        }
    }
}
</style>
